<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">大型仪器设备预约申请</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="formInline.serial_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="serial_no" fixed label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="status" label="审批状态" width="150" label-class-name="applyStatus2"
          :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="start_time"  label="开放开始日期" width="160px">
        </custom-table-column>
        <custom-table-column prop="end_time"  label="开放结束日期" width="160px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属组织结构" width="210">
          <template slot-scope="scope"  >
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="usage"  label="用途" width="160px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" v-if="scope.row.status == 1">
            <el-button @click="handlEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="仪器设备" prop="new_device_individual_id">
          <el-cascader v-model="ruleForm.new_device_individual_id" filterable ref="cascader" :props="props"
            style="width:552px;" clearable :options="eqs"></el-cascader>
        </el-form-item> 
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.start_time" style="width: 216px;" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
            v-model="ruleForm.end_time" style="width: 216px;"  :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item label="用途" prop="usage">
          <el-input type="textarea" v-model="ruleForm.usage" placeholder="请输入" style="width:552px;" :rows="5"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        status:'',
        serial_no: '',
        device_name: '',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - 24*60*60*1000);
        },
      },
      props: {
        emitPath: false
      },
      ruleForm: {
        new_device_individual_id:'',
        start_time: '',
        end_time: '',
        usage: '',
      },
      eqs: [],
      rules: {
        new_device_individual_id: [{ required: true, message: '请选择', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择', trigger: 'change' }],
        usage: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
    };
  },
  components: {},
  created() {
    this.initEqs();
  },
  mounted() {
  },
  methods: {
    async initEqs() {
      await this.$store.dispatch('getEqs',{is_big_device:1})
      this.eqs = this.$store.state.allEqs.map(item => {
        let children = []
        if (item.individuals && item.individuals.length > 0) {
          children = item.individuals.map(child => {
            return {
              value: child.id,
              label: child.serial_no
            }
          })
        }
        return {
          value: item.id,
          label: item.device_name,
          children
        }
      })
    },
    handlEdit(row) {
      const line = this.$until.easyDeepCopy(row)
      if(line.opening_time_slot){
        line.opening_time_slot = line.opening_time_slot.split('-')
      } 
      this.handleEditNew(line)
    },  
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/big/device/appointment/destroy/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/big/device/appointment/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if(params.opening_time_slot){
        params.opening_time_slot = params.opening_time_slot.join('-')
      }
      let res = await this.$api.instance.interfaceServer('api/big/device/appointment/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      if(params.opening_time_slot){
        params.opening_time_slot=params.opening_time_slot.join('-')
      }
      let res = await this.$api.instance.interfaceServer(`api/big/device/appointment/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
